<template>
  <div>
    <el-drawer
        title="展示项配置"
        :visible.sync="show"
        :direction="direction"
        :before-close="handleClose">
      <div class="content-wrapper">
        <el-form  :model="ruleForm" :rules="rules" ref="ruleForm"  label-width="100px" class="demo-ruleForm">
          <el-form-item label="表头配置" prop="tableHeaders">
            <el-checkbox-group v-model="ruleForm.tableHeaders">
              <el-checkbox
                  :label="v.prop"
                  v-for="(v, i) in tableHeaders"
                  :key="i"
                  :disabled="disabledTableHeaders.indexOf(v.prop) > -1"
              >{{ v.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="支付方式" prop="paytypeidList">
            <el-checkbox-group v-model="ruleForm.paytypeidList">
              <el-checkbox
                  :label="v.paytypeid"
                  v-for="(v, i) in paytypeList"
                  :key="i"
              >{{ v.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="mt40 flex item-center flex-end mr20">
        <el-button type="primary" @click="submitConfig">确定</el-button>
      </div>

    </el-drawer>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: "rtl"
    },
    storeCode: {
      type: String,
      default: ""
    },
    dataType: {
      type: String,
      default: "gjp"
    },
    tableHeaders: {
      type: Array,
      default: () => []
    },
    selectedTableHeaders: {
      type: Array,
      default: () => []
    },
    disabledTableHeaders: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ruleForm: {
        paytypeidList: [],
        tableHeaders: [],
      },
      rules: {
        paytypeidList: [
          { type: 'array', required: true, message: '请至少选择一个支付方式', trigger: 'change' }
        ],
        tableHeaders: [
          { type: 'array', required: true, message: '请至少选择一个表头配置', trigger: 'change' }
        ],
      },
      paytypeList: [],
      usePaytypeidList: [],
    };
  },
  created() {},
  mounted() {
    this.ruleForm.tableHeaders = [];
    if (this.selectedTableHeaders && this.selectedTableHeaders.length > 0) {
      this.ruleForm.tableHeaders = this.selectedTableHeaders.map(v => v.prop);
    }
    this.queryAllPayType();
    this.queryUsePayType();
  },
  methods: {
    queryAllPayType() {
      if (this.dataType === "gjp") {
        this.queryGjpAllPayTypeList();
      }
    },
    async queryGjpAllPayTypeList() {
      let params = {
        storeCode: this.storeCode
      };
      const { result } = await this.$store.dispatch("queryGjpAllPayTypeList", params);
      this.paytypeList = result;
    },
    queryUsePayType() {
      if (this.dataType === "gjp") {
        this.queryGjpUsePayTypeList();
      }
    },
    async queryGjpUsePayTypeList() {
      let params = {
        storeCode: this.storeCode
      };
      const { result } = await this.$store.dispatch("queryGjpUsePayTypeList", params);
      let list = [];
      result.forEach(v => {
        list.push(Number(v));
      });
      this.ruleForm.paytypeidList = list;
      this.usePaytypeidList = JSON.parse(JSON.stringify(list));
    },
    submitConfig() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.dataType === "gjp") {
            this.editGjpUsePayType();
          }
        } else {
          return false;
        }
      });
    },
    async editGjpUsePayType() {
      let ids = JSON.parse(JSON.stringify(this.ruleForm.paytypeidList));
      ids.sort(function(a, b){return a - b});
      let params = {
        storeCode: this.storeCode,
        paytypeids: ids.join(",")
      }
      await this.$store.dispatch("editGjpUsePayType", params);
      this.$message({
        message: "操作成功",
        type: "success"
      });
      this.handleClose();
    },
    handleClose(done) {
      let refreshFlag = JSON.stringify(this.usePaytypeidList) === JSON.stringify(this.ruleForm.paytypeidList) ? false : true;
      this.$emit("closeConfigShow", {show: false, doRefresh: refreshFlag, tableHeaders: this.ruleForm.tableHeaders});
      // done();
    },
  }
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  overflow-y: auto;
  width: 100%;
  max-height: 600px;
}
.content-wrapper::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}
.content-wrapper::-webkit-scrollbar-thumb {
  background: rgb(224, 214, 235);
}
</style>